<ng-select
    #select
    [items]="items"
    bindValue="value"
    bindLabel="label"
    [class]="ngSelectClass"
    [ngClass]="{
        'highlight-animated': highlightAnimated,
        'highlight-focused': highlightFocused
    }"
    [placeholder]="placeholder"
    [loading]="loading"
    [clearable]="false"
    [multiple]="false"
    [searchable]="false"
    [closeOnSelect]="true"
    [(ngModel)]="value"
    [disabled]="disabled || loading"
    (ngModelChange)="selectionChanged($event)"
    (focus)="focus()"
    (click)="onHighlightFocus()"
    [notFoundText]="'GENERAL.NO_DATA' | translate"
>
    <!-- <ng-template ng-header-tmp></ng-template> -->
    <ng-container *ngIf="searchable">
        <ng-template ng-header-tmp>
            <div *ngIf="searchable" class="search-header">
                <input
                    type="text"
                    [placeholder]="'SELECT.SEARCH_PLACEHOLDER' | translate"
                    (input)="applyFilter(select, $event)"
                />
                <span class="material-symbols-rounded" aria-hidden="true"> search </span>
            </div>
        </ng-template>
    </ng-container>

    <ng-template ng-option-tmp let-item$="item$" let-item="item" let-index="index">
        <div>
            {{ item.label }}
        </div>
    </ng-template>

    <ng-template ng-footer-tmp></ng-template>

    <ng-template ng-notfound-tmp>
        <div class="no-items-found">{{ ngSelectComponent.notFoundText }}</div>
    </ng-template>
</ng-select>
